// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39pRM","largestCol":"styles_largestCol__I7tGu","smallestCol":"styles_smallestCol__2_0Bc"};